import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { formulateName } from "src/utility";
import { getItemLabel, getItemPrice, getRowTotal, getSSRItems, SSRSelectionLayoutProps } from "../utils";

const SSRSelectionTableMob = ({ rows, columns, type, formatPrice, totalLabel, grandTotal }: SSRSelectionLayoutProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="flex flex-col">
      {isExpanded &&
        rows.map(({ key, passenger, typeIndex }) => {
          const passengerType = t(`Flights.details.passengerType.${passenger.type.toLowerCase()}`);
          const name = formulateName(passenger.basicData?.firstName ?? passengerType);
          const total = getRowTotal(passenger, columns, type);
          return (
            <div key={key} className="border-border-subtle flex flex-col gap-2 border-b px-4 py-3">
              <div className="flex items-center justify-between gap-2">
                <div className="flex min-w-0 items-center gap-2">
                  <span className="bg-background-primary text-font-inverted flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold">
                    {name?.charAt(0)}
                  </span>
                  <span className="text-font-default truncate text-sm font-semibold">{name}</span>
                  <span className="text-font-subtle shrink-0 text-xs">
                    {`${passengerType} ${typeIndex}`}
                  </span>
                </div>
                {total ? (
                  <span className="text-font-default shrink-0 text-sm font-semibold">{formatPrice(total)}</span>
                ) : (
                  <span className="text-font-minimal">—</span>
                )}
              </div>
              {columns.map((column) => {
                const items = getSSRItems(passenger, column, type);
                const columnTotal = items.reduce((sum, item) => sum + getItemPrice(item), 0);
                return (
                  <div key={column.key} className="flex items-center justify-between gap-2 ps-8 text-xs">
                    <span className="text-font-subtle truncate">
                      {items.length ? `${column.title} · ${items.map((item) => getItemLabel(item, type)).join(", ")}` : column.title}
                    </span>
                    {items.length ? (
                      <span className="text-font-active shrink-0 font-semibold">{formatPrice(columnTotal)}</span>
                    ) : (
                      <span className="text-font-minimal shrink-0">—</span>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      <div className="bg-background-informative flex items-center justify-between gap-2 px-4 py-3">
        <span className="text-font-default text-sm font-semibold">{totalLabel}</span>
        <div className="flex shrink-0 items-center gap-2">
          <span className="text-font-active text-lg font-bold">{formatPrice(grandTotal)}</span>
          <button
            onClick={() => setIsExpanded((prev) => !prev)}
            className="bg-background-default text-font-active rounded-pill flex cursor-pointer items-center gap-1 px-3 py-1 text-xs font-semibold shadow-sm"
          >
            {isExpanded ? t("Flights.details.ssr.hide", { defaultValue: "Hide" }) : t("Flights.details.ssr.show", { defaultValue: "Show" })}
            {isExpanded ? <MdKeyboardArrowUp size={16} /> : <MdKeyboardArrowDown size={16} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SSRSelectionTableMob;
